export const VEHICLE_TYPES = [
  'Sedan',
  'SUV',
  'EV Sedan',
  'EV SUV',
  '12 Seater',
  '22 Seater',
  '28 Seater',
  '33 Seater',
  '38 Seater',
  '40 Seater',
  '50 Seater',
];

export const VEHICLE_SEATING_DEFAULTS = {
  'Sedan': '4',
  'SUV': '7',
  'EV Sedan': '4',
  'EV SUV': '7',
  '12 Seater': '12',
  '22 Seater': '22',
  '28 Seater': '28',
  '33 Seater': '33',
  '38 Seater': '38',
  '40 Seater': '40',
  '50 Seater': '50',
};

export const getVehicleTypeBadgeStyle = (type) => {
  const norm = String(type || '').toLowerCase();
  if (norm.includes('ev')) {
    return { bg: '#E0F2FE', color: '#0369A1' }; // Electric Blue
  }
  if (norm.includes('suv')) {
    return { bg: '#F0F4FF', color: '#5B6EF4' }; // Indigo
  }
  if (norm.includes('seater')) {
    return { bg: '#FEF3C7', color: '#D97706' }; // Amber
  }
  return { bg: '#EEF8F3', color: '#20B967' }; // Emerald Green
};
